import { render, staticRenderFns } from "./orerator-form-docs.vue?vue&type=template&id=4b36db20&lang=pug&"
import script from "./orerator-form-docs.vue?vue&type=script&lang=js&"
export * from "./orerator-form-docs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports